import React from "react";

function CustomHomeDashboard() {
  return <div>CustomHomeDashboard</div>;
}

export default CustomHomeDashboard;
